import { Component, OnInit } from '@angular/core';
import { SelectItem } from '@mydocma/dynamic-form';
import {AttributeGroupFile} from '@docma-mm-core/attribute-group/attribute-group-file';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'mydocma-mm-attribute-dropdown-tile',
  templateUrl: './mm-attribute-dropdown-tile.component.html',
  styleUrls: ['./mm-attribute-dropdown-tile.component.scss']
})
export class MmAttributeDropdownTileComponent implements OnInit {
  private itemInternal: SelectItem;

  imageUrl: any;

  constructor(private readonly sanitizer: DomSanitizer) {
  }
  ngOnInit(): void {
  }

  public get item() {
    return this.itemInternal;
  }

  public set item(value: any) {
    this.itemInternal = value;

    if (this.itemInternal?.data?.buffer) {
      const url = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(new Blob([this.itemInternal.data.buffer])));
      this.imageUrl = url;
    }
  }

  async getImage() {
    const file = (this.item.data as AttributeGroupFile);
    return file?.ImageFileName;
  }
}
